// used to manually restrict wildcard URL params
export const VENUES_REPORTS_TYPES = {
  BOOKINGS: 'venues-bookings',
  REVENUE: 'venues-revenue',
};

export const PAYOUT_TRANSACTION_TYPES = {
  RESERVATIONS: 'reservations',
  ADJUSTMENT: 'adjustments',
};

export const PAYOUT_STATUS = {
  FAILED: 'FAILED',
  POSTED: 'POSTED',
};

export const STATS_TAB_TYPES = {
  YOUR_INSIGHTS: 'your-insights',
  MARKET_INSIGHTS: 'market-insights',
  REPORTS: 'reports',
};

export const STATS_TABS = [STATS_TAB_TYPES.YOUR_INSIGHTS, STATS_TAB_TYPES.MARKET_INSIGHTS, STATS_TAB_TYPES.REPORTS];

// more general list used for building valid paths
export const REPORT_TYPES = {
  BOOKINGS: 'bookings',
  CAMPAIGNS: 'campaigns',
  CLASSES: 'classes',
  RESERVATIONS: 'reservations',
  SUMMARY: 'summary',
  TRANSACTIONS: 'transactions',
  MONTHLY: 'monthly',
};

export const RESERVATION_REPORT_STATUS = {
  ATTENDED: 'attended',
  FIRST_CLASS_FREE: 'first_class_free',
  FREQUENT_VISITOR: 'frequent_visitor',
  LATE_CANCEL_WAIVED: 'late_cancel_waived',
  MISSED_CLASS: 'missed_class',
  PREMIUM: 'premium',
  REBOOKED: 'rebooked',
  USER_LATE_CANCEL: 'user_late_cancel',
  GOODWILL_PAID: 'goodwill_paid',
};

// endpoints can take any number, but the design calls for 50 and has no way for the user to change it
// results per page on payouts report
export const PAYOUTS_PER_PAGE = 10;
// results per page on reservations report
export const RESERVATIONS_PER_PAGE = 50;
// results per page on schedules report
export const SCHEDULES_PER_PAGE = 50;
// results per page on transactions report
export const TRANSACTIONS_PER_PAGE = 50;

// no API interactions; just a hardcoded table size
export const MONTHLY_REPORTS_PER_PAGE = 50;

export const DEFAULT_RANGE_WEEKS = 4;
export const VALID_RANGES_WEEKS = [4, 8, 12];

export const YOUR_INSIGHTS_CATEGORIES = {
  CAPACITY: 'capacity',
  CORPORATE: 'corporate',
  CUSTOMER_INSIGHTS: 'customerInsights',
  OVERVIEW: 'overview',
  RATINGS_REVIEWS: 'ratingsReviews',
  SAFETY_CLEANLINESS: 'safetyCleanliness',
};

export const YOUR_INSIGHTS_CATEGORIES_SORTED = [
  YOUR_INSIGHTS_CATEGORIES.OVERVIEW,
  YOUR_INSIGHTS_CATEGORIES.CORPORATE,
  YOUR_INSIGHTS_CATEGORIES.CUSTOMER_INSIGHTS,
  YOUR_INSIGHTS_CATEGORIES.RATINGS_REVIEWS,
  YOUR_INSIGHTS_CATEGORIES.CAPACITY,
  YOUR_INSIGHTS_CATEGORIES.SAFETY_CLEANLINESS,
];

export const YOUR_INSIGHTS_MODULE_TYPES = {
  AVERAGE_RATING: 'average_rating',
  CLASSPASS_UTILIZATION: 'classpass_utilization',
  CORPORATE_RESERVATIONS: 'corporate_reservations',
  CORPORATE_REVENUE: 'corporate_revenue',
  FIRST_TIME_VISITORS: 'first_time_visitors',
  IOS_APP_IMPRESSIONS: 'ios_app_impressions',
  RESERVATIONS_RATINGS_BREAKDOWN: 'reservations_ratings_breakdown',
  RESERVATIONS_STATUSES_BREAKDOWN: 'reservations_statuses_breakdown',
  RESERVATIONS: 'reservations',
  REVENUE: 'revenue',
  SAFETY_AND_CLEANLINESS_MEASURES: 'safety_and_cleanliness_measures',
  SAFETY_MET_EXCEEDED: 'safety_met_exceeded',
  TOP_LOYAL_VISITORS: 'top_loyal_visitors',
  TOP_RATED_CLASSES: 'top_rated_classes',
  TOP_RATED_INSTRUCTORS: 'top_rated_instructors',
  UNMONETIZED_SPOTS: 'unmonetized_spots',
  USER_FREQUENCY_CALLOUT: 'user_frequency_callout',
  VISITORS_BOOKED_BEFORE: 'visitors_booked_before',
  VISITORS_FIRST_VS_RETURNING: 'visitors_first_vs_returning',
  VISITORS_RETURN_RATE: 'visitors_return_rate',
};

export const YOUR_INSIGHTS_MODULE_TYPES_BY_CATEGORY = {
  [YOUR_INSIGHTS_CATEGORIES.OVERVIEW]: [YOUR_INSIGHTS_MODULE_TYPES.REVENUE, YOUR_INSIGHTS_MODULE_TYPES.RESERVATIONS],
  [YOUR_INSIGHTS_CATEGORIES.CORPORATE]: [
    YOUR_INSIGHTS_MODULE_TYPES.CORPORATE_REVENUE,
    YOUR_INSIGHTS_MODULE_TYPES.CORPORATE_RESERVATIONS,
  ],
  [YOUR_INSIGHTS_CATEGORIES.CUSTOMER_INSIGHTS]: [
    YOUR_INSIGHTS_MODULE_TYPES.VISITORS_FIRST_VS_RETURNING,
    YOUR_INSIGHTS_MODULE_TYPES.RESERVATIONS_STATUSES_BREAKDOWN,
    YOUR_INSIGHTS_MODULE_TYPES.VISITORS_RETURN_RATE,
    YOUR_INSIGHTS_MODULE_TYPES.USER_FREQUENCY_CALLOUT,
    YOUR_INSIGHTS_MODULE_TYPES.IOS_APP_IMPRESSIONS,
    YOUR_INSIGHTS_MODULE_TYPES.VISITORS_BOOKED_BEFORE,
    YOUR_INSIGHTS_MODULE_TYPES.TOP_LOYAL_VISITORS,
    YOUR_INSIGHTS_MODULE_TYPES.FIRST_TIME_VISITORS,
  ],
  [YOUR_INSIGHTS_CATEGORIES.RATINGS_REVIEWS]: [
    YOUR_INSIGHTS_MODULE_TYPES.AVERAGE_RATING,
    YOUR_INSIGHTS_MODULE_TYPES.RESERVATIONS_RATINGS_BREAKDOWN,
    YOUR_INSIGHTS_MODULE_TYPES.TOP_RATED_INSTRUCTORS,
    YOUR_INSIGHTS_MODULE_TYPES.TOP_RATED_CLASSES,
  ],
  [YOUR_INSIGHTS_CATEGORIES.SAFETY_CLEANLINESS]: [
    YOUR_INSIGHTS_MODULE_TYPES.SAFETY_MET_EXCEEDED,
    YOUR_INSIGHTS_MODULE_TYPES.SAFETY_AND_CLEANLINESS_MEASURES,
  ],
  [YOUR_INSIGHTS_CATEGORIES.CAPACITY]: [
    YOUR_INSIGHTS_MODULE_TYPES.UNMONETIZED_SPOTS,
    YOUR_INSIGHTS_MODULE_TYPES.CLASSPASS_UTILIZATION,
  ],
};
